import React, { useState } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { toggleForm } from "../redux/eventOrganiserSlice";
import Popup from "../Popup";
import {
  fetchChecklist,
  fetchOrgUsers,
  submitTask,
  updateAssignedUsers,
  updateTaskStatus,
} from "../redux/eventOrganiserThunks";
import AllFeatureDataTable from "../../../GuiComponents/AllFeatureDataTable.table";
import userStore from "../../../zustand/userStore";

const ChecklistSection = () => {
  const dispatch = useDispatch();
  const showForm = useSelector((state) => state.eventOrganiser.showForm);

  const { selectedActivity, checklist, users } = useSelector(
    (state) => state.eventOrganiser
  );
  // const { roleData } = useSelector((store) => store.eventOrganiser);

  const [selectedUsers, setSelectedUsers] = useState([]);
  const userData = userStore((state) => state.user);
  const [selectedData, setSelectedData] = useState();
  const userOptions = users.map((user) => ({
    value: user.id,
    label: user.name,
  }));

  console.log("checklist", checklist);
  const [showAssignPopup, setShowAssignPopup] = useState(false);

  const onAssignClick = (item) => {
    dispatch(fetchOrgUsers());
    setSelectedData(item);
    const assigned = item.assigned_users ? JSON.parse(item.assigned_users) : [];
    setSelectedUsers(assigned);

    setShowAssignPopup(true);
  };
  console.log("selectedData", selectedData);

  const [formData, setFormData] = useState({
    taskName: "",
    description: "",
  });

  const tableData = [
    {
      Header: "Sl no",
      accessor: "sno",
    },
    {
      Header: "Task Name",
      accessor: "task_name",
    },
    {
      Header: "Task Details",
      accessor: "task_details",
    },
    {
      Header: "Created At",
      accessor: "created_at",
    },
    {
      Header: "Status",
      accessor: "status",
      // Cell: ({ value }) => (Number(value) === 1 ? "Approved" : "Pending"),
    },
    {
      Header: "Actions",
      accessor: "actionId",
    },
  ];

  const handleStatusToggle = (item, newStatus) => {
    dispatch(updateTaskStatus({ taskId: item.id, status: newStatus }))
      .unwrap()
      .then(() => {
        dispatch(fetchChecklist(selectedActivity[0]?.id));
      })
      .catch((err) => {
        console.error("Failed to update status:", err);
      });
  };

  // const handleStatusToggle = (item) => {
  //   const newStatus = Number(item.status) === 1 ? 0 : 1;
  //   dispatch(updateTaskStatus({ taskId: item.id, status: newStatus }))
  //     .unwrap()
  //     .then(() => {
  //       dispatch(fetchChecklist(selectedActivity[0]?.id));
  //     })
  //     .catch((err) => {
  //       console.error("Failed to update status:", err);
  //     });
  // };

  // const processData = (eventsArray) => {
  //   return eventsArray.map((item, index) => ({
  //     ...item,
  //     sno: index + 1,
  //     actionId: (
  //       <>
  //         {/* {roleData?.[0]?.role == 1 && ( */}
  //         {userData.role === "super admin" && (
  //           <>
  //             {" "}
  //             <i
  //               data-tip="Assign User"
  //               title="Assign User"
  //               className="fa fa-user-plus"
  //               style={{ color: "blue", cursor: "pointer" }}
  //               onClick={() => onAssignClick(item)}
  //             />
  //             <button
  //               onClick={() => handleStatusToggle(item)}
  //               style={{
  //                 marginLeft: "10px",
  //                 padding: "2px 4px",
  //                 backgroundColor: Number(item.status) === 1 ? "red" : "green",
  //                 color: "white",
  //                 border: "none",
  //                 borderRadius: "4px",
  //                 cursor: "pointer",
  //               }}
  //             >
  //               {Number(item.status) === 1 ? "Reject" : "Approve"}
  //             </button>
  //           </>
  //         )}
  //       </>
  //     ),
  //   }));
  // };

  const processData = (eventsArray) => {
    return eventsArray.map((item, index) => {
      const currentStatus = Number(item.status);
      const statusMap = {
        0: "Pending",
        1: "Inprogress",
        2: "Completed",
      };
      const nextStatuses = [0, 1, 2].filter(
        (status) => status !== currentStatus
      );

      return {
        ...item,
        sno: index + 1,
        created_at: item.created_at ? (
          <span>{new Date(item.created_at).toLocaleString()}</span>
        ) : null,
        status: statusMap[currentStatus],
        actionId: (
          <>
            {userData.role === "super admin" && (
              <>
                <i
                  data-tip="Assign User"
                  title="Assign User"
                  className="fa fa-user-plus"
                  style={{
                    color: "blue",
                    cursor: "pointer",
                    marginRight: "10px",
                  }}
                  onClick={() => onAssignClick(item)}
                />
                {nextStatuses.map((status) => (
                  <button
                    key={status}
                    onClick={() => handleStatusToggle(item, status)}
                    style={{
                      marginRight: "6px",
                      padding: "4px 8px",
                      backgroundColor:
                        status === 0
                          ? "gray"
                          : status === 1
                          ? "green"
                          : "purple",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      fontSize: "12px",
                      cursor: "pointer",
                    }}
                  >
                    {statusMap[status]}
                  </button>
                ))}
              </>
            )}
          </>
        ),
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);

    const TaskData = {
      event_id: selectedActivity[0].event_id,
      activity_id: selectedActivity[0]?.id,
      task_name: formData.taskName,
      task_details: formData.description,
    };

    dispatch(submitTask({ TaskData }))
      .unwrap()
      .then((res) => {
        console.log("Task submitted:", res);
        setFormData({
          taskName: "",
          description: "",
        });
        dispatch(toggleForm(false));
        dispatch(fetchChecklist(selectedActivity[0]?.id));
      })
      .catch((err) => {
        console.error("Submission error:", err);
      });
  };

  const handleAssignUsers = async (e) => {
    e.preventDefault();
    try {
      dispatch(
        updateAssignedUsers({
          taskId: selectedData.id,
          assignedUsers: selectedUsers,
        })
      )
        .unwrap()
        .then(() => {
          return dispatch(fetchChecklist(selectedActivity[0]?.id));
        })
        .then(() => {
          setShowAssignPopup(false);
        })
        .catch((err) => {
          console.error("Failed to assign users:", err);
        });
    } catch (err) {
      console.error("Failed to assign users:", err);
    }
  };

  const getFilteredChecklist = () => {
    // if (roleData?.[0]?.role === 1) {
    if (userData.role === "super admin") {
      return checklist;
    }
    return checklist.filter((item) => {
      try {
        const assigned = JSON.parse(item.assigned_users || "[]");
        return assigned.some((user) => user.id === userData.id);
      } catch (e) {
        console.error("Invalid assigned_users JSON", e);
        return false;
      }
    });
  };

  return (
    <div style={{ marginLeft: "20px", marginRight: "20px" }}>
      {/* {roleData?.[0]?.role == 1 && ( */}
      {userData.role === "super admin" && (
        <button
          onClick={() => dispatch(toggleForm(true))}
          style={{
            padding: "5px 10px",
            backgroundColor: "#1976d2",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          + Add Task
        </button>
      )}

      {/* <div className="mt-2">
        {checklist.length > 0 ? (
          <AllFeatureDataTable
            columns={tableData}
            data={processData(checklist)}
          />
        ) : (
          <div>No Data Found</div>
        )}
      </div> */}
      <div className="mt-2">
        {getFilteredChecklist().length > 0 ? (
          <AllFeatureDataTable
            columns={tableData}
            data={processData(getFilteredChecklist())}
          />
        ) : (
          <div>No Data Found</div>
        )}
      </div>

      {showForm && (
        <Popup
          title="Create A New Task"
          minHeight="400px"
          maxWidth="800px"
          jsustifyContent="center"
          onClose={() => dispatch(toggleForm(false))}
        >
          <div
            style={{
              maxWidth: "500px",
              margin: "0 auto",
              padding: "20px",
              backgroundColor: "#f9f9f9",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "5px",
                    fontWeight: "bold",
                  }}
                >
                  Task Name:
                </label>
                <input
                  type="text"
                  value={formData.taskName}
                  onChange={(e) =>
                    setFormData({ ...formData, taskName: e.target.value })
                  }
                  required
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                />
              </div>

              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "5px",
                    fontWeight: "bold",
                  }}
                >
                  Description:
                </label>
                <textarea
                  value={formData.description}
                  onChange={(e) =>
                    setFormData({ ...formData, description: e.target.value })
                  }
                  required
                  rows={4}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    resize: "vertical",
                  }}
                />
              </div>

              <button
                type="submit"
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#28a745",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  width: "25%",
                }}
              >
                Submit
              </button>
            </form>
          </div>
        </Popup>
      )}
      {showAssignPopup && (
        <Popup
          title="Assign Users"
          onClose={() => setShowAssignPopup(false)}
          minHeight="400px"
          maxWidth="800px"
          jsustifyContent="center"
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              padding: "20px",
            }}
          >
            <form
              onSubmit={handleAssignUsers}
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                maxWidth: "500px",
                backgroundColor: "#f9f9f9",
                padding: "20px",
                borderRadius: "8px",
                boxShadow: "0 0 10px rgba(0,0,0,0.1)",
              }}
            >
              <label style={{ marginBottom: "8px", fontWeight: "bold" }}>
                Select Users:
              </label>
              <Select
                isMulti
                options={userOptions}
                value={selectedUsers.map((user) => ({
                  value: user.id,
                  label: user.name,
                }))}
                onChange={(selectedOptions) =>
                  setSelectedUsers(
                    selectedOptions.map((opt) => ({
                      id: opt.value,
                      name: opt.label,
                    }))
                  )
                }
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                    maxHeight: 200,
                    overflowY: "auto",
                  }),
                  menuList: (provided) => ({
                    ...provided,
                    maxHeight: 200,
                    overflowY: "auto",
                  }),
                }}
              />

              <button
                type="submit"
                style={{
                  marginTop: "160px",
                  width: "20%",
                  padding: "10px",
                  backgroundColor: "#1976d2",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Assign
              </button>
            </form>
          </div>
        </Popup>
      )}
    </div>
  );
};

export default ChecklistSection;
